import { gql } from "@apollo/client";

export const GET_FUNDRAISING_ANALYTICS_DASHBOARD_DATA = gql`
  query getFundraisingAnalyticsDashboardData(
    $input: GetFundraisingAnalyticsDashboardDataInput!
  ) {
    getFundraisingAnalyticsDashboardData(input: $input) {
      id
      computedAt
      computeJob {
        id
        status
      }
      recentPerformance {
        roi
        averageDonationDollars
        totalRaisedDollars
        textsSent
        donations
        totalRaisedOneTimeDollars
        donorConversionRate
        linkConversionRate
        totalRaisedRecurringDollars
      }
      historicalPerformance {
        roi
        averageDonationDollars
        totalRaisedDollars
      }
      topPerformingCampaigns {
        campaignId
        campaignName
        campaignStartDate
        roi
        textsSent
        totalRaisedDollars
        donations
        averageDonationDollars
        donorConversionRate
      }
      monthlyStats {
        month
        roi
        firstWeekRoi
        textsSent
        amountRaisedOnetimeDollars
        amountRaisedRecurringDollars
        averageDonationDollars
        averageFirstWeekDonationDollars
        donorConversionRate
        linkConversionRate
      }
    }
  }
`;

export const COMPUTE_FUNDRAISING_ANALYTICS_DASHBOARD_DATA = gql`
  mutation computeFundraisingAnalyticsDashboardData(
    $input: ComputeFundraisingAnalyticsDashboardDataInput!
  ) {
    computeFundraisingAnalyticsDashboardData(input: $input) {
      id
    }
  }
`;

export const GET_ORGANIZING_ANALYTICS_DASHBOARD_DATA = gql`
  query getOrganizingAnalyticsDashboardData(
    $input: GetOrganizingAnalyticsDashboardDataInput!
  ) {
    getOrganizingAnalyticsDashboardData(input: $input) {
      id
      computedAt
      computeJob {
        id
        status
      }
      textsSent
      replyRate
      optOutRate
      conversations
      tagsApplied
      activeTexters
      campaignOverview {
        campaignId
        campaignName
        campaignStartDate
        textsSent
        activeTexters
        conversations
        replyRate
        optOutRate
      }
      texterLeaderboard {
        userId
        fullName
        subaccountName
        joinDate
        textsSent
        tagsApplied
        conversations
      }
      topTags {
        tagId
        tagName
        taggedCampaignContacts
        rank
      }
      repliesAndOptOuts {
        campaignStartDate
        replyRate
        optOutRate
        conversations
      }
    }
  }
`;

export const COMPUTE_ORGANIZING_ANALYTICS_DASHBOARD_DATA = gql`
  mutation computeOrganizingAnalyticsDashboardData(
    $input: ComputeOrganizingAnalyticsDashboardDataInput!
  ) {
    computeOrganizingAnalyticsDashboardData(input: $input) {
      id
    }
  }
`;
